import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import { AgendaItemDateTime } from "../../managers/agenda/types/agenda";

// ----------------------------------------------------------------------

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(relativeTime);

// ----------------------------------------------------------------------

/**
 * Convertit un objet dateTimeTimeZone de Microsoft Graph en ISO string
 * @param dateTimeTimeZone - L'objet Graph contenant dateTime et timeZone (corresponding internal class : AgendaItemDateTime)
 * @returns ISO string UTC ou null si invalide
 */
export function parseGraphDateTimeToIsoString(
    dateTimeTimeZone: AgendaItemDateTime | undefined,
): string | null {
    if (!dateTimeTimeZone?.dateTime) {
        return null;
    }

    let dateStr = dateTimeTimeZone.dateTime;

    // Microsoft Graph retourne des dates avec jusqu'à 7 chiffres après le point
    // JavaScript Date ne supporte que 3 chiffres (millisecondes)
    // On tronque proprement les chiffres excédentaires
    dateStr = dateStr.replace(/(\.\d{3})\d*/, "$1");

    // Si pas d'indicateur de timezone dans la string (Z, +XX:XX, -XX:XX)
    // ET que timeZone est UTC ou non spécifié, on ajoute 'Z'
    const hasTimezoneIndicator =
        dateStr.endsWith("Z") ||
        dateStr.includes("+", 10) ||
        dateStr.includes("-", 10);

    if (!hasTimezoneIndicator) {
        const tz = dateTimeTimeZone.timeZone;
        // Par défaut, Graph utilise UTC si timeZone n'est pas spécifié
        if (!tz || tz === "UTC") {
            dateStr += "Z";
        }
    }

    try {
        // Date() parse maintenant correctement et toISOString() normalise
        return new Date(dateStr).toISOString();
    } catch (error) {
        console.error(
            "Failed to parse Graph dateTime:",
            dateTimeTimeZone,
            error,
        );
        return null;
    }
}
